import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { ClientValidation } from 'uplisting-frontend/validations';

export default class ClientRepositoryService extends BaseRepositoryService<
  ModelRegistry['client']
> {
  recordName = 'client';
  implementMethods = [
    'findAll',
    'findRecord',
    'createRecord',
    'buildChangeset',
    'save',
  ];

  validation = ClientValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/client': ClientRepositoryService;
  }
}
